var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootterMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 15.4168L7.5 14.1668L2.5 16.6668V5.8335L7.5 3.3335L12.5 5.8335L17.5 3.3335V9.5835",
    stroke: "#F6F7F8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.3335V14.1668",
    stroke: "#F6F7F8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.8335V10.4168",
    stroke: "#F6F7F8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6009 16.7675C17.9506 16.4179 18.1888 15.9725 18.2853 15.4875C18.3818 15.0025 18.3323 14.4998 18.1431 14.043C17.9539 13.5861 17.6335 13.1956 17.2224 12.9209C16.8112 12.6462 16.3279 12.4995 15.8334 12.4995C15.3389 12.4995 14.8555 12.6462 14.4444 12.9209C14.0332 13.1956 13.7128 13.5861 13.5236 14.043C13.3344 14.4998 13.2849 15.0025 13.3815 15.4875C13.478 15.9725 13.7162 16.4179 14.0659 16.7675C14.4142 17.1167 15.0034 17.6384 15.8334 18.3334C16.7092 17.5917 17.2992 17.07 17.6009 16.7675Z",
    stroke: "#F6F7F8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 15V15.0079",
    stroke: "#F6F7F8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootterMap);
export default __webpack_public_path__ + "static/media/footter_map.08ae80e9b3b23b1af4a119e4a382adc2.svg";
export { ForwardRef as ReactComponent };